export enum DatePickerType {
    Year,
    Day,
    Comparison,
}
